import { DynamicBase } from "@arktype/util";
import { arkKind } from "./shared/utils.js";
export class RootModule extends DynamicBase {
    // ensure `[arkKind]` is non-enumerable so it doesn't get spread on import/export
    get [arkKind]() {
        return "module";
    }
}
export const SchemaModule = RootModule;
